<script>
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import DiscussionFilter from './discussion_filter.vue';

export default {
  components: {
    TimelineToggle: () => import('./timeline_toggle.vue'),
    DiscussionFilter,
    AiSummarizeNotes: () =>
      import('ee_component/notes/components/note_actions/ai_summarize_notes.vue'),
    MrDiscussionFilter: () => import('./mr_discussion_filter.vue'),
  },
  mixins: [glAbilitiesMixin(), glFeatureFlagsMixin()],
  inject: {
    showTimelineViewToggle: {
      default: false,
    },
    resourceGlobalId: { default: null },
    mrFilter: {
      default: false,
    },
  },
  props: {
    notesFilters: {
      type: Array,
      required: true,
    },
    notesFilterValue: {
      type: Number,
      default: undefined,
      required: false,
    },
    aiLoading: {
      type: Boolean,
      default: false,
      required: false,
    },
    noteableType: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    showAiActions() {
      return (
        this.resourceGlobalId &&
        this.glAbilities.summarizeComments &&
        this.glFeatures.summarizeComments
      );
    },
  },
};
</script>

<template>
  <div
    class="gl-flex gl-flex-col gl-justify-between gl-pb-3 gl-pt-5 @sm/panel:gl-flex-row @sm/panel:gl-items-center"
  >
    <h2 class="gl-heading-2 gl-m-0">{{ __('Activity') }}</h2>
    <div class="gl-mt-3 gl-flex gl-w-full gl-gap-3 @sm/panel:gl-mt-0 @sm/panel:gl-w-auto">
      <ai-summarize-notes
        v-if="showAiActions"
        :work-item-type="noteableType"
        :resource-global-id="resourceGlobalId"
        :loading="aiLoading"
      />
      <timeline-toggle v-if="showTimelineViewToggle" />
      <mr-discussion-filter v-if="mrFilter" />
      <discussion-filter v-else :filters="notesFilters" :selected-value="notesFilterValue" />
    </div>
  </div>
</template>
